module.exports = __webpack_public_path__ + "static/media/launch-academy-logo.0827974c.svg";